import { useDispatch } from 'react-redux';

import generateId from 'src/lib/generateId';
import {
  buildCustomHeaderMap,
  verifyNameValueList,
} from 'src/presentation/components/pages/integrations/editorComponents/helpers';

export default function useOnSave({ customHeadersRef }) {
  const dispatch = useDispatch();
  return ({ add, isNew, resetErrors, update, validate, workingStateRef }) => {
    dispatch(resetErrors());

    const knownHeaders = workingStateRef.current.headersKeys || [];
    const errors = verifyNameValueList(customHeadersRef.current, knownHeaders);
    if (!errors.length) {
      // Convert temporary header list into the final structure and try to save
      const headers = buildCustomHeaderMap(customHeadersRef.current, knownHeaders);
      workingStateRef.current.headers = headers;
    }

    const currentWorkingState = workingStateRef.current;

    const workingStateToUpdate = {
      ...currentWorkingState,
      ...(currentWorkingState.name ? { name: currentWorkingState.name.trim() } : {}),
      id: isNew ? generateId() : currentWorkingState.id,
    };

    if (!dispatch(validate(workingStateToUpdate, errors))) {
      return;
    }

    isNew
      ? dispatch(add({}, workingStateToUpdate))
      : dispatch(update({ id: workingStateRef.current.id }, workingStateToUpdate, { patch: true }));
  };
}
